<template>
    <focus-lock>
        <div
            role="dialog"
            aria-modal="true"
            :class="{ cz2__blur: blurBg }"
            class="cz2__modal-popup cz2__base-modal"
            @click="overlayClick"
        >
            <div
                ref="baseModalWrapper"
                :class="[
                    { 'cz2__ai-modal-bg': showBg },
                    { 'cz2__ai-modal__circle-bg': showCircle },
                ]"
                class="cz2__base-modal-content-wrapper"
            >
                <div class="cz2__base-modal-content">
                    <slot />
                </div>

                <button
                    v-if="showClose"
                    type="button"
                    aria-label="Close"
                    @click="closeAndMaybeMore"
                    class="cz2__base-modal-close"
                />
            </div>
        </div>
    </focus-lock>
</template>

<style lang="scss">
    @import "../../style/variables.scss";

    #cz2.cz2 {
        .cz2__base-modal {
            z-index: 100000;

            &.cz2__blur {
                backdrop-filter: blur(20px);
            }

            .cz2__base-modal-content-wrapper {
                position: relative;
                border-radius: 32px;

                &.cz2__ai-modal-bg {
                    background-color: white;
                }

                &.cz2__ai-modal__circle-bg {
                    background-image: url('../../assets/images/ai-circle-mobile.webp');
                    background-repeat: no-repeat;
                    background-position: bottom right;
                    background-size: 85% 50%;
                }
            }

            .cz2__base-modal-content {
                height: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
            }

            .cz2__base-modal-close {
                position: absolute;
                top: 16px;
                right: 16px;

                width: 24px;
                height: 24px;
                background: transparent url(../../assets/icons/close-round.svg) no-repeat center/contain;
            }

            @include respond-above(lg) {
                .cz2__base-modal-content-wrapper {
                    &.cz2__ai-modal__circle-bg {
                        background-image: url('../../assets/images/ai-circle.webp');
                        background-position: top right;
                        background-size: 55% 100%;
                    }
                }
            }
        }
    }
</style>

<script>
    import { animate } from 'motion';

    import FocusLock from 'vue-focus-lock';

    import Btn from './Btn.vue';

    export default {
        components: {
            FocusLock,
            Btn,
        },

        props: {
            showBg: {
                type: Boolean,
                default: true,
            },

            showCircle: {
                type: Boolean,
                default: false,
            },

            showClose: {
                type: Boolean,
                default: true,
            },

            zoomIn: {
                type: Boolean,
                default: false,
            },

            blurBg: {
                type: Boolean,
                default: false,
            },
        },

        computed: {
            // Redefine what mobile means to accommodate special tablet styling
            isAiMobile() {
                return window.innerWidth < 640;
            },

            switchPopModalShown() {
                return this.$store.state.switchPopModalShown;
            },

            aiModalShown() {
                return this.$store.state.aiModalShown;
            },

            isFirstPop() {
                return this.$store.state.customizer.viewController === this.$store.getters.popControllers[0];
            },
        },

        mounted() {
            if ((this.zoomIn && !this.isAiMobile) || (this.isAiMobile && !this.switchPopModalShown)) {
                this.animateModal();
            }
        },

        methods: {
            closeAndMaybeMore() {
                if (this.aiModalShown && this.isFirstPop) {
                    this.startOver();
                } else {
                    this.close();
                }
            },

            close() {
                this.$emit('close');
            },

            startOver() {
                this.$store.state.customizer.mainController.trackAction({
                    action: 'ai-selfie-restart',
                });

                window.location.reload();
            },

            overlayClick(event) {
                if (event.target === this.$el) {
                    this.close();
                }
            },

            animateModal() {
                animate(this.$refs.baseModalWrapper, {
                    transform: [
                        'scale(0.2)',
                        'scale(1)',
                    ],
                }, {
                    duration: 0.35,
                    easing: 'ease-out',
                });
            },
        },
    };
</script>
